export default __webpack_public_path__ + "static/media/calloutRect.c2810c9f.svg";